module.exports = __webpack_public_path__ + "img/view_device_c4.94e73f00.jpg";